import { CrmService } from '@/services';

export default {
  searchContacts({ commit }, { query, cancelToken }) {
    const searchApi = query.textToSearch ? CrmService.searchContacts : CrmService.searchContactsAdvanced;
    return searchApi(query, { cancelToken })
      .then(response => {
        commit('addContacts', response.data.contacts);
        return CrmService.getNotesBatch(response.data.contacts.map(contact => contact.id));
      })
      .then(batchNotesResponse => {
        (batchNotesResponse.data || []).forEach(({ contactId, notes }) => {
          commit('setContactNotes', { contactId, data: notes });
        });
        return batchNotesResponse.data;
      });
  },

  retrieveContactNotes({ commit }, contactId) {
    return CrmService.getNotes(contactId).then(({ data }) => {
      commit('setContactNotes', { contactId, data });
    });
  },

  searchLists({ commit }, searchString) {
    commit('setContactLists', []);
    return CrmService.getLists(searchString).then(response => {
      commit('setContactLists', response.data);
    });
  },

  removeContact({ commit }, contactId) {
    commit('removeContact', contactId);
  },

  clearContacts({ commit }) {
    commit('setContacts', []);
  },

  removeList({ commit }, listId) {
    commit('removeList', listId);
  }
};
